import React, {useState} from 'react'
import RaiseTicketsBoard from '../RaiseTicket/RaiseTicketsBoard'
import DatePicker from '../GenericTable/CommonDatePicker'

function RaiseTicket() {
  const [issueType, setIssueType] = useState<string>('All')
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [selectedDays, setSelectedDays] = useState({
    startDate: '',
    endDate: '',
  })

  return (
    <>
      <div className='p-2 bg-white'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flex: 1,
              alignItems: 'center',
              // marginLeft: '70px',
            }}
          >
            <div style={{ marginRight: '5px' }}>
              <select
                value={issueType}
                onChange={(e) => setIssueType(e.target.value)}
                className="form-select form-select-sm form-select-solid w-100px w-xxl-125px"
              >
                <option value="All">All</option>
                <option value="Task">Task</option>
                <option value="Bug">Bug</option>
                <option value="Other">Other</option>
              </select>
            </div>
            
          </div>
          <div >
                <input
                  type='text'
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  data-kt-roles-table-filter='search'
                  className='form-control form-control-solid w-250px ps-15'
                  placeholder='search by title or id'
                />
            </div>
          <div>
          <DatePicker setSelectedDays={setSelectedDays} selectedDays={selectedDays}/>
          </div>
          
        </div>
        <RaiseTicketsBoard issueType={issueType} searchQuery={searchQuery} selectedDays={selectedDays} />
      </div>
    </>
  )
}

export default RaiseTicket
